module.exports = __webpack_public_path__ + "img/LIFESTYLE.141ac987.jpg";